import React from "react";
import { htmlDecode } from "../../functions/htmldecoder";

const OtherFacets = ({
  other,
  index,
  renderViewMoreButton,
  handleFacet,
  translate,
  handleFacetTitleClick,
  renderFacetToggleIcon,
  activeFacetTitles,
  activeShowMoreFacets,
  buttonsState,
  facetImageGenerator
}) => {
  let name = other.name;
  let facetTitle = other.title.replace("ic_", "").replace(/[_]/g, " ").trim();

  if (facetTitle === "Sellers") {
    facetTitle = translate("Stores");
  }
  let numberOfFacetsValuesWithCountMoreThanZero = other.facetValues.filter(
    f => f.count > 0
  ).length;

  let isActive = activeFacetTitles.some(t => t === name);

  let isViewMoreActive = activeShowMoreFacets.some(t => t === name);
  if (numberOfFacetsValuesWithCountMoreThanZero > 0) {
    return (
      <div key={index} className="facetTitleWrapper">
        {Object.keys(buttonsState[name]).length > 0 ? (
          <h2
            role="button"
            aria-expanded={isActive}
            data-facettitle={other.name}
            onClick={e => handleFacetTitleClick(e, other.name, isActive)}
            className={
              Object.values(buttonsState[name]).some(k => k === false)
                ? "facet-has-checked-option facetTitle"
                : "facetTitle"
            }
          >
            {facetTitle.replace("ic ", "")}
            {renderFacetToggleIcon(isActive)}
          </h2>
        ) : null}

        <div
          aria-expanded={isActive}
          className={`${
            isActive
              ? "facetFilterWrapper scroll-bar-thin-style active"
              : "facetFilterWrapper scroll-bar-thin-style"
          } ${isViewMoreActive ? "view-more-active" : ""}`}
        >
          <ul className={isActive ? "priceFacet open" : "priceFacet"}>
            {other.facetValues.map((subother, index) => {
              if (subother.count > 0) {
                return (
                  <li key={subother.value} className="facetFilterContent">
                    <div
                      onKeyDown={e => {
                        const key = e.key;
                        if (key === "Enter") {
                          if (e.target) e.target.click();
                        }
                      }}
                      onClick={() =>
                        handleFacet(
                          subother.value,
                          index,
                          name,
                          buttonsState[name][index],
                          { [facetTitle]: subother.text }
                        )
                      }
                      key={subother.value}
                      name={subother.value}
                      style={
                        subother.count > 0
                          ? { opacity: "1", cursor: "pointer" }
                          : {
                              opacity: "0.6",
                              cursor: "not-allowed"
                            }
                      }
                      tabIndex="0"
                    >
                      <span
                        className={
                          buttonsState[name][index]
                            ? "checkmark-box"
                            : "checkmark-box checked"
                        }
                      ></span>

                      {
                        // renders an Image if there is any for specific facets like FINISH facet
                        facetImageGenerator(facetTitle, subother.text)
                      }
                      <span
                        className="productText"
                        dangerouslySetInnerHTML={{ __html: subother.text }}
                      ></span>
                      <span className="productCount">({subother.count})</span>
                    </div>
                  </li>
                );
              }
            })}
          </ul>
        </div>

        <div
          className={`view-more-button-wrapper ${
            isViewMoreActive ? "view-more-active" : ""
          }`}
        >
          {renderViewMoreButton(
            numberOfFacetsValuesWithCountMoreThanZero,
            isActive,
            isViewMoreActive,
            other.name
          )}
        </div>
      </div>
    );
  } else return null;
};

export default OtherFacets;
